import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import Meta from './Meta'
import Nav from './Nav'
import Transition from './Transition'
import Consent from './Consent'
import queryString from 'query-string'

import 'modern-normalize/modern-normalize.css'
import './globalStyles.css'

export default ({ children, location, meta, title }) => {

  if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('utm_source') === null) {
    const params = queryString.parse(location.search);
    sessionStorage.setItem('utm_source', params.utm_source);
    sessionStorage.setItem('utm_medium', params.utm_medium);
    sessionStorage.setItem('utm_campaign', params.utm_campaign);
    sessionStorage.setItem('utm_content', params.utm_content);
  };

  return (
    <StaticQuery
      query={graphql`
        query IndexLayoutQuery {
          settingsYaml {
            siteTitle
            siteDescription
            googleTrackingId
            socialMediaCard {
              image
            }
          }
          allPosts: allMarkdownRemark(
            filter: { fields: { contentType: { eq: "postCategories" } } }
            sort: { order: DESC, fields: [frontmatter___date] }
          ) {
            edges {
              node {
                fields {
                  slug
                }
                frontmatter {
                  title
                }
              }
            }
          }
        }
      `}
      render={data => {
        const { siteTitle, socialMediaCard, googleTrackingId } =
            data.settingsYaml || {},
          subNav = {
            posts: data.allPosts.hasOwnProperty('edges')
              ? data.allPosts.edges.map(post => {
                  return { ...post.node.fields, ...post.node.frontmatter }
                })
              : false
          }

        return (
          <Fragment>
            <Helmet
              defaultTitle={siteTitle}
              titleTemplate={`%s | ${siteTitle}`}
            >
              {title}
              <link href="https://ucarecdn.com" rel="preconnect" crossorigin />
              <link rel="dns-prefetch" href="https://ucarecdn.com" />
              <script data-ad-client="ca-pub-9909384188743272" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
            </Helmet>

            <Meta
              googleTrackingId={googleTrackingId}
              absoluteImageUrl={
                socialMediaCard &&
                socialMediaCard.image &&
                socialMediaCard.image
              }
              {...meta}
              {...data.settingsYaml}
            />

            <Nav subNav={subNav} />

            <Transition location={location}>{children}</Transition>

            <script type="text/javascript" async="async" src="https://tags.premiumads.com.br/dfp/de27938a-ea15-4ccc-90e1-b91a5a7eff11"></script>

          </Fragment>

        )
      }}
    />
  )
}
